// Employee profile page (Initiatives / Change Impacts / Tasks / Stakeholder Profiles tabs)

// Debounce for the header search field, same as the previous initiatives search
export const EMPLOYEE_PROFILE_SEARCH_DEBOUNCE_MS = 400;

// When true, tab links keep the current ?search= value, so the search persists
// across tabs. When false, switching tabs resets the search.
export const CARRY_SEARCH_ACROSS_TABS = false;

// Breadcrumb for the employee page: "Organization / {Employee name}".
// Set to true to restore the previous "Organization / Employees / {Employee name}".
export const SHOW_EMPLOYEES_BREADCRUMB_SEGMENT = false;

// "Show all owners, one per line" (true) vs. the default "2 owners + N" (false)
export const EMPLOYEE_PROFILE_SHOW_ALL_OWNERS = true;

export const EMPLOYEE_PROFILE_PER_PAGE = 10;

// Hide Stakeholder Profiles controls the viewer cannot use (a 403 signs the user
// out). Logic lives in lib/employeeProfilePermissions.js. Set to false to show
// everything to everyone, as before.
export const ENFORCE_EMPLOYEE_TAB_PERMISSIONS = true;

export const CHANGE_IMPACT_ROLES = {
  OWNER: 'owner',
  IMPACTED: 'impacted',
};
